import React from "react";
import './AddToCalendarButton.scss';

export const AddToCalendarButton = ({onClick}) => (
    <button className='add-to-calendar-button' onClick={onClick}>
      Add to calendar
    </button>
  );
